import React, { useMemo } from "react";
import { getServerUri } from "../modules/uriUtility";
import _ from "lodash";
import DialogDeleteShell from "./DialogDeleteShell";

function displayFileName(record) {
  const file = _.get(record, "file", "");
  const ext = file.includes(".") ? file.substring(file.lastIndexOf(".")) : "";
  const baseName = _.get(record, "uploadedFileName") || _.get(record, "fontSet") || file;
  return baseName && !String(baseName).includes(".") && ext ? baseName + ext : baseName;
}

export default function DialogBitmapFontDelete(props) {
  const fontSetRecords = useMemo(
    () => (props.bitmapFonts || []).filter((entry) => entry.fontSet === props.fontSetToDeleteID),
    [props.fontSetToDeleteID, props.bitmapFonts]
  );
  const fontSetToSearch = fontSetRecords[0] || null;
  const assetNames = useMemo(
    () => fontSetRecords.map((r) => displayFileName(r)).filter(Boolean),
    [fontSetRecords]
  );

  const handleDelete = (progressID) => {
    return fetch(getServerUri("bitmapFont/deleteFontSet"), {
      method: "DELETE",
      headers: { "content-type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        accessToken: localStorage.getItem("session.accessToken"),
        fontSetID: String(props.fontSetToDeleteID || ""),
        progressID: progressID || "",
      }),
    }).then((response) => {
      if (response.status === 200) {
        const next = (props.bitmapFonts || []).filter(
          (entry) => entry.fontSet !== props.fontSetToDeleteID
        );
        props.deleteFontSetFromBitmapFonts?.(props.fontSetToDeleteID);
        props.setBitmapFonts?.(next);
        props.createSnackbar("Bitmap font deleted", "success");
        props.onAfterDelete?.();
        return true;
      }
      response.text().then(console.log).catch(console.error);
      return false;
    });
  };

  return (
    <DialogDeleteShell
      isOpen={props.isOpen}
      setIsOpen={props.setIsOpen}
      assetNames={assetNames}
      assetID={_.get(fontSetToSearch, "_id")}
      assetFile={_.get(fontSetToSearch, "file")}
      assetType="bitmap-font"
      onConfirmDelete={handleDelete}
      createSnackbar={props.createSnackbar}
      errorMessage="An error occurred deleting the bitmap font."
    />
  );
}
